import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';
export interface IPurgeLogFileFormMeta {
  startDate: FormInputMeta,
  endDate: FormInputMeta,
  schema: any,
}

const PurgeLogFileFormMeta: IPurgeLogFileFormMeta = {} as IPurgeLogFileFormMeta;

PurgeLogFileFormMeta.startDate = {
  label: 'Date de début',
  name: 'startDate',
  type: 'date',
  validation: yup.date().required(),
};

PurgeLogFileFormMeta.endDate = {
  label: 'Date de fin',
  name: 'endDate',
  type: 'date',
  validation: yup.date().required(),
};

const validationSchema = getValidationSchema(PurgeLogFileFormMeta);
PurgeLogFileFormMeta.schema = yup.object().shape(validationSchema);


export default PurgeLogFileFormMeta;